
const calcScrollProgress = (minScroll, maxScroll, decimals = 2) => {

    const range = maxScroll - minScroll;
    const rawProgress = Math.min(1, (window.scrollY - minScroll) / range).toFixed(decimals);

    return rawProgress;
}

const lerp = (a, b, t) => {
    return Number(a) + (Number(b) - Number(a)) * Number(Math.min(1, t));
}

const bezier = (t) => {
    return t * t * (3 - 2 * t);
}

const parametric = (t) => {
    return t * t / (2 * (t * t - t) + 1);
}

const decodeCSSunitToPx = (value) => {

    if (value.indexOf('px') !== -1) {
        return parseInt(value);
    }
    if (value.indexOf('vh') !== -1) {
        return (window.innerHeight / 100) * parseInt(value);
    }
}

const int_hs_ui_background_layer = () => {

    // get reqired elements
    const bgLayer = document.querySelector('.wp-block-hs-blocks-ui-main-bg-layer') || false;
    const bgImage = bgLayer.querySelector('.ui-bg-image') || false;
    const bgColor = bgLayer.querySelector('.ui-bg-color') || false;
    const bgScrollBounceUnderlay = bgLayer.querySelector('.ui-bg-scroll-bounce-underlay') || false;

    const siteFooter = document.querySelector('footer') || false;

    // config
    const cfg = {
        enabled: uiMainBgLayerSettings.enableLerping,
        lerpingRange: [
            uiMainBgLayerSettings.lerpingRange[0],
            uiMainBgLayerSettings.lerpingRange[1],
        ],
        power: 2,
        blurRange: [
            uiMainBgLayerSettings.blurRange[0],
            uiMainBgLayerSettings.blurRange[1],
        ],
        scaleRange: [
            uiMainBgLayerSettings.scaleRange[0],
            uiMainBgLayerSettings.scaleRange[1],
        ]
    }

    console.log(cfg)

    // lookUp array for performance-related optimizations
    let lookUpAR = {
        scrollPosY: null,
        innerHeight: null,
    };

    // update function
    const update = () => {

        if ((lookUpAR.scrollPosY === window.scrollY) && (lookUpAR.innerHeight === window.innerHeight)) {
            return;
        }

        // process bg image
        if (cfg.enabled) {
            const scrollPorgress = calcScrollProgress(
                decodeCSSunitToPx(cfg.lerpingRange[0]),
                decodeCSSunitToPx(cfg.lerpingRange[1]),
                2
            );
            const t = parametric(scrollPorgress);

            const bgBlurVal = lerp(cfg.blurRange[0], cfg.blurRange[1], t);
            const bgScaleVal = lerp(cfg.scaleRange[0], cfg.scaleRange[1], t);

            bgImage.style.filter = `blur(${bgBlurVal}px)`;
            bgImage.style.transform = `scale(${bgScaleVal})`;
        }

        // process bg color


        // process bg scroll bounce underlay
        if (siteFooter) {

            const siteFooterRect = siteFooter.getBoundingClientRect();
            const underlayColor = getComputedStyle(siteFooter.lastElementChild).backgroundColor;
            const underlayPosTop = Math.min(window.innerHeight, siteFooterRect.top) + siteFooterRect.height;

            bgScrollBounceUnderlay.style.backgroundColor = underlayColor;
            bgScrollBounceUnderlay.style.top = `${underlayPosTop - 200}px`;

        }

        // update lookup array
        lookUpAR.scrollPosY = window.scrollY;
        lookUpAR.innerHeight = window.innerHeight;

    }

    hs_core.addTask(update);
}

int_hs_ui_background_layer();